if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.syncAutoAddSettingsFromMainForm();
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            if (this.shouldAddAutoVariant(formData)) {
              this.addAutoVariant(formData, response);
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      syncAutoAddSettingsFromMainForm() {
        if (this.dataset.enableAutoAdd === 'true' || this.dataset.autoAddTriggerId || this.dataset.autoAddVariantId) {
          return;
        }

        const mainProductForm = document.querySelector('product-form[data-enable-auto-add="true"]');
        if (!mainProductForm) return;

        this.dataset.enableAutoAdd = mainProductForm.dataset.enableAutoAdd || 'false';
        this.dataset.autoAddTriggerId = mainProductForm.dataset.autoAddTriggerId || '';
        this.dataset.autoAddVariantId = mainProductForm.dataset.autoAddVariantId || '';
      }

      shouldAddAutoVariant(formData) {
        const enabled = this.dataset.enableAutoAdd === 'true';
        const triggerId = this.normalizeVariantId(this.dataset.autoAddTriggerId);
        const autoVariantId = this.normalizeVariantId(this.dataset.autoAddVariantId);
        const selectedVariantId = this.normalizeVariantId(this.variantIdInput?.value || formData.get('id'));

        return enabled && triggerId && autoVariantId && selectedVariantId === triggerId;
      }

      normalizeVariantId(value) {
        return String(value ?? '')
          .replace(/\s+/g, '')
          .trim();
      }

      addAutoVariant(formData, mainResponse) {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const autoFormData = new FormData();
        autoFormData.append('id', this.dataset.autoAddVariantId);
        autoFormData.append('quantity', formData.get('quantity') || 1);

        if (this.cart) {
          autoFormData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          autoFormData.append('sections_url', window.location.pathname);
        }

        config.body = autoFormData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: this.dataset.autoAddVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          });

        if (this.cart) {
          this.cart.renderContents(mainResponse);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
